module.exports = __webpack_public_path__ + "img/back-organization.63425153.webp";